/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

// domain/navigation/navigation.loader.js

import { navigationState } from "./navigation.state"
import { fetchNavigation } from "./navigation.api"
import { mapNavigation } from "./navigation.structure.mapper"
import { navigationFallbackData } from "./navigation.fallback"

const NAV_MODE = import.meta.env.VITE_NAV_MODE

async function applyDB() {
    const res = await fetchNavigation()
    navigationState.categories = res.data.categories || []
    navigationState.items = res.data.items || []
    navigationState.rescueMode = false
    navigationState.source = "db"
}

function applyFallback() {
    navigationState.categories = navigationFallbackData.categories
    navigationState.items = navigationFallbackData.items
    navigationState.rescueMode = true
    navigationState.source = "fallback"
}

function applyLocalControlPlane() {
    const category = navigationFallbackData.categories.find(item => item.entity_key === "control-plane")
    const item = navigationFallbackData.items.find(entry => entry.entity_key === "instance")

    if (category && !navigationState.categories.some(entry => (entry.entity_key ?? entry.key ?? entry.id) === "control-plane")) {
        navigationState.categories.push({ ...category })
    }

    if (item && !navigationState.items.some(entry => (entry.entity_key ?? entry.key ?? entry.id) === "instance")) {
        navigationState.items.push({ ...item })
    }
}

function finalizeNavigation() {

    applyLocalControlPlane()

    navigationState.structure =
        mapNavigation(
            navigationState.categories,
            navigationState.items
        )
}

export async function loadNavigation() {

    if (NAV_MODE) {

        switch (NAV_MODE) {

            case "fallback":
                applyFallback()
                break

            case "db":
                await applyDB()
                break

            default:
                throw new Error("Invalid NAV_MODE value")
        }

    } else {

        try {

            await applyDB()
            navigationState.rescueMode = false

        } catch (e) {

            console.warn("Navigation DB failed. Activating rescue mode.")

            applyFallback()
            navigationState.rescueMode = true
        }

    }

    finalizeNavigation()

    navigationState.ready = true
}
